var $2ae24b959273b5c1$exports = {};
$2ae24b959273b5c1$exports = {
    "loading": `Loading...`,
    "noResults": `No results`,
    "clear": `Clear`,
    "invalid": `(invalid)`,
    "valid": `(valid)`
};


export {$2ae24b959273b5c1$exports as default};
//# sourceMappingURL=en-US.module.js.map
